// BE#313 — pure helper: the distinct, non-null dripIds present on a campaigns array. Used by
// getPendingAndRuningCampaigns to load the DRIP docs for the fetched drip-step campaigns, so the
// calendar can expand each drip's follow-up steps (the drip doc, not just the step campaign, must be
// in the store). Kept standalone + pure so it is unit-testable without the feathers-heavy thunk file.
export function dripIdsFromCampaigns(
    campaigns: ReadonlyArray<{ dripId?: string | null } | null | undefined>,
): string[] {
    const ids = new Set<string>();
    for (const c of campaigns ?? []) {
        if (c && c.dripId) ids.add(String(c.dripId));
    }
    return [...ids];
}

export { IN_CHUNK, chunkIds } from './in-query';
